import React, { useContext, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../authcontext/AuthContext';
import axios from 'axios';
import { config } from '../../utils/config'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

export default function Header() {

    const authData = useContext(AuthContext);
    const navigate = useNavigate();
    // Manage the state of Offcanvas
    const [show, setShow] = useState(false);

    // Close Offcanvas
    const closeOffcanvas = () => setShow(false);
    // Open Offcanvas
    const openOffcanvas = () => setShow(true);

    const logout = useCallback(async () => {
        // withCredentials is to send session/cookie info to server
        await axios.post(`${config.apiBaseUrl}/user-logout`, {}, { withCredentials: true })
        navigate("/")
        authData.updateIsAuth(false)
        authData.updateIsAgentAuth(false)
        authData.updateUserDetail(null)
        authData.updateToken(null)
    }, [navigate, authData])

    return (
        <>
            {['lg'].map((expand) => (
                <Navbar key={expand} bg="light" expand={expand} className="mb-3">
                    <Container fluid>
                        <Link className="nav-link" to="/"><Navbar.Brand>HSA</Navbar.Brand></Link>
                        <Navbar.Offcanvas show={show} onHide={closeOffcanvas}
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end">
                            <Offcanvas.Header closeButton >
                                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                                    Quick Links
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body onClick={closeOffcanvas}>
                                {(!authData.getIsAgentAuth() && !authData.getIsAuth()) ?
                                    <Nav className="justify-content-start">
                                        <Nav.Link as={Link} to="/aboutus" >About Us</Nav.Link>
                                        <Nav.Link as={Link} to="/propertylisting" >Property Listings</Nav.Link>
                                        <Nav.Link as={Link} to="/bidding" >Bid Property</Nav.Link>
                                    </Nav> :
                                    null
                                }

                                {(authData.getIsAuth()) ?
                                    <Nav className="justify-content-start flex-grow-1 pe-3">
                                        <Link className="nav-link" to="/aboutus">About Us</Link>
                                        <Link className="nav-link" to="/propertylisting">Property Listings</Link>
                                        <Link className="nav-link" to="/bidding">Bid Property</Link>
                                        <Link className="nav-link" to="/property/add">Add Property</Link>
                                        <Link className="nav-link" to="/user/dashboard">User Dashboard</Link>
                                    </Nav>
                                    :
                                    null

                                }
                                {(authData.getIsAgentAuth()) ?
                                    <Nav className="justify-content-start flex-grow-1 pe-3">
                                        <Link className="nav-link" to="/aboutus">About Us</Link>
                                        <Link className="nav-link" to="/propertylisting">Property Listings</Link>
                                        <Link className="nav-link" to="/agent/dashboard">Dashboard</Link>
                                        <Link className="nav-link" to="/property/add">Add Property</Link>
                                    </Nav>
                                    :
                                    null

                                }

                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                        <Nav className="justify-content-end ms-auto pe-3">
                            {(authData.getIsAuth() || authData.getIsAgentAuth()) ?
                                <button className="btn btn-danger btn-sm" onClick={logout}>Logout</button>
                                :
                                <Link className="btn btn-danger btn-sm" to="/login">Login</Link>
                            }
                            {/* {(authData.getIsAgentAuth()) ?
                                <button className="btn btn-danger btn-sm" onClick={logout}>Logout</button>
                                :
                                <Link className="btn btn-danger btn-sm" to="/login">Login</Link>
                            } */}
                        </Nav>
                        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={openOffcanvas} />
                    </Container>
                </Navbar>
            ))}

        </>
    );
}


